import styled from '@emotion/styled';
import Banner from 'patient-ping-remedy/packages/banner';
import {colors} from 'patient-ping-remedy/packages/theme';

export const QueueDropdownWrapper = styled.div`
  margin-top: 1.6rem;
`;

export const StyledBanner = styled(Banner)`
  margin-bottom: 1.6rem;
`;

export const QueueDetails = styled.div`
  margin-top: 1.2rem;
  font-size: 1.2rem;
  color: ${colors.gray5};
`;
